<template>
  <div class="search-conditions" :class="show ? 'border-wrap' : 'border-top'">
    <!-- <div class="toggle-warp"> -->
    <div class="toggle-wrap" @click="show = !show">
      <i
        :class="show ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline'"
      ></i>
      <span class="toggle-text"> <slot name="text">查询条件</slot></span>
    </div>
    <!-- </div> -->
    <el-collapse-transition>
      <div class="search-content" v-show="show">
        <slot name="content"></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
    };
  },
};
</script>
<style lang="scss" scoped>
.search-conditions {
  position: relative;
  margin: 10px 0;
  padding: 0 10px;
  .toggle-wrap {
    position: absolute;
    background-color: #ffffff;
    padding: 0 10px;
    font-weight: 500;
    left: 20px;
    transform: translateY(-50%);
    top: 0;
    display: flex;
    .toggle-text {
      font-size: 14px;
      margin-left: 2px;
    }
  }
  .search-content {
    &::before,
    &::after {
      content: " ";
      display: block;
      height: 10px;
    }
    &::before {
      height: 15px;
    }
  }
}
.border-wrap {
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.border-top {
  border-top: 1px solid #dcdfe6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.04);
  //   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
